import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppState } from 'store'
import { programActions } from 'store/slices/programs'
import { useParams, useLocation } from 'react-router'
import { Location } from 'models/location'
import Button from 'components/Button/Button'
import {
  PublicProgramTitle,
  PublicProgramContent,
  PublicProgramBody,
  PublicProgramContainer,
  PublicProgramCopyMsg,
  PublicProgramCopySection,
} from './PublicProgram.styled'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { getPublicProgramFragment } from 'utils/htmlParser'
import { isNumber, isNaN } from 'lodash'

const ProgramPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const { locationId }: Location = useParams()
  const { search } = useLocation()
  const { publicPrograms } = useAppState(state => state.programs)
  const [isCopied, setIsCopied] = useState(false)
  const htmlSnipper = getPublicProgramFragment(publicPrograms)

  useEffect(() => {
    if (locationId) {
      const keyValuePairs = search.split("?").slice(1);
      const queryObject: any = {};
      
      keyValuePairs.forEach(keyValuePair => {
        const [key, value] = keyValuePair.split("=");
        queryObject[key] = value;
      });

      if(queryObject.programId) {
        const programArray: number[] = queryObject.programId?.split(',').map(Number);
        queryObject.programId = programArray.filter((program: number | null) => {
          if (isNumber(program) && !isNaN(program)) {
            return program
          }
        })
      }

      dispatch(
        programActions.getPublicPrograms({
          locationId: locationId,
          programIds: queryObject.programId ?? [],
          endDate: queryObject.endDate ?? '',
          searchText: queryObject.search_text ?? "",
        })
      )
    }
  }, [])

  const onCopyText = () => {
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 1000)
  }

  return (
    <PublicProgramContainer>
      <PublicProgramTitle>Public Program</PublicProgramTitle>
      <PublicProgramContent>
        <PublicProgramBody>
          <div>
            <pre>{Array.isArray(publicPrograms) ? htmlSnipper : publicPrograms}</pre>
            <CopyToClipboard text={htmlSnipper} onCopy={onCopyText}>
              <PublicProgramCopySection>
                <Button
                  key={'copy-button'}
                  text={'copy'}
                  variant="primary"
                  preset="ghost"
                  size={'small'}
                />
                <PublicProgramCopyMsg>
                  {isCopied && 'Copied!'}
                </PublicProgramCopyMsg>
              </PublicProgramCopySection>
            </CopyToClipboard>
          </div>
        </PublicProgramBody>
      </PublicProgramContent>
    </PublicProgramContainer>
  )
}

export default ProgramPage
